import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Menu, Label, Icon, Sticky } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import logo from 'img/logo.svg'
import { closeClient } from 'data/advisor/client/action'
import { logout } from 'data/auth/action'
import { setAdvisorClientHeader, setAuthorisationHeader, withRouter } from 'globals/utils'
import './style.css'

class Navigation extends React.Component {
  constructor(props) {
    super(props)
    const {currentClient, clientName, planId} = sessionStorage 
    this.state = {
      activeItem: '',
      activeApp: null,
      loading: false,
      isProspect: false,
      currentClient: currentClient,
      clientName: clientName,
      planId: planId
    }
  }
  componentDidMount() {
    this.setActive(this.props)
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) { 
      this.setActive(this.props)
    }
    if (prevProps.activeClient !== this.props.activeClient) {
      if (!!this.props.activeClient && (this.props.activeClient.category==='EDITONLY' || this.props.activeClient.category==='Prospect')) {
        sessionStorage.setItem('currentIsProspect', true)   
        this.setState({isProspect: true})     
      } else {
        sessionStorage.removeItem('currentIsProspect')
        this.setState({isProspect: false})
      }
    }
  }

  setActive = (p) => {
    const path = p.location.pathname.split('/')
    if(path.includes('advisor')){
      if(path.includes('prospects')){
        this.setState({
          activeItem: 'prospects', activeApp: null
        }) 
      } else if(path.includes('messages')){
        this.setState({
          activeItem: 'messages', activeApp: null
        }) 
      } else if(path.includes('create')){
        this.setState({
          activeItem: 'create', activeApp: null
        }) 
      } else if(path.includes('clients')){
        this.setState({
          activeItem: 'clients', activeApp: null
        })
      } else if(path.includes('client')){
        this.setState({
          activeItem: 'client', activeApp: null
        })
      } else if(path.includes('settings')){
        this.setState({
          activeItem: 'drawdown',
        }) 
      } else if(path.includes('drawdown')){
        this.setState({
          activeItem: 'drawdown', activeApp: 'bmc'
        })
      } else if(path.includes('bmc')){
        this.setState({
          activeItem: 'plans',  activeApp: 'bmc'
        })
      } else {
        this.setState({
          activeItem: 'advisor',
        })
      }
    } else if(path.includes('home')){
      this.setState({
        activeItem: 'home', activeApp: null
      }) 
    } else if(path.includes('future')){
      this.setState({
        activeItem: 'future', activeApp: 'bmc'
      })
    } else if(path.includes('thisyear')){
      this.setState({
        activeItem: 'thisyear', activeApp: 'bmc'
      })
    } else if(path.includes('events')){
      this.setState({
        activeItem: 'events', activeApp: 'bmc'
      })
    } else if(path.includes('reports')){
      this.setState({
        activeItem: 'reports', activeApp: 'bmc'
      })
    } else if(path.includes('tours')){
      this.setState({
        activeItem: 'tours', activeApp: 'bmc'
      })  
    } else if(path.includes('utilities')){ 
      this.setState({ 
        activeItem: 'utilities',
      })
    } else if(path.includes('faq')){
      this.setState({
        activeItem: 'faq',
      })  
    } else if(path.includes('settings')){
      this.setState({
        activeItem: 'user',
      }) 
    } else if(path.includes('changelog')){
      this.setState({
        activeItem: 'user'
      }) 
    } else {
      this.setState({
        activeItem: 'this_year',
      })
    }
  }
  
  logout = () => {
    sessionStorage.clear()
    setAuthorisationHeader(null)
    this.props.logout('/app/login')
  }

  closeFile = () => {
    const {planId } = sessionStorage
    const { isProspect } = this.state
    this.props.closeClient().then(()=>{
      setAdvisorClientHeader()
      
      sessionStorage.removeItem('currentClient')
      sessionStorage.removeItem('clientName')
      sessionStorage.removeItem('planId')
      sessionStorage.removeItem('currentIsProspect')
      this.setState({
        currentClient: undefined,
        clientName: undefined,
        planId: undefined
      })
      if (isProspect) {
        this.props.navigate('/advisor/prospects')
      } else {
        this.props.navigate('/advisor')
      }
    })
  }

  render() {
    const { activeItem, activeApp, loading, isProspect } = this.state
    const { isAdvisor, activeClients, unread, plan, isTrial } = this.props  
    const { primary, partner, tawkTo } = this.props.user_data
    const { userName, currentClient, clientName, firstName } = sessionStorage
    let view_only = (plan.id==='view')
    let displayName = firstName
    let currentPlan = undefined
    let activeName = undefined
    if (isAdvisor) { 
      currentPlan = plan.description 
      if (primary) {
        if (primary.lastName.length > 15) {
          activeName = primary.lastName.substring(0, 15) 
        } else {
          activeName = primary.lastName
        }
        activeName += ", " + primary.name + (!!partner ? (' & ' + partner.name) : '')
      }
    }
    if (!isAdvisor && primary) { displayName = partner ? primary.name + ' & ' + partner.name : primary.name}
    if (!loading && !!tawkTo) { appendTawkTo(userName, displayName, tawkTo) }
    
    return (
      <div id='navMenu' className='ui container'>
        <Sticky>
        <Menu> 
          <Menu.Item>
            <img id='logo' src={logo} alt='logo'/>
          </Menu.Item>

          { isAdvisor && !currentClient && 
            <Menu.Item
              name='dashboard'
              active={activeItem === 'advisor'}
              as={Link}
              to={'/advisor'}
              >
              Dashboard
            </Menu.Item> 
          }
          { process.env.REACT_APP_TYPE==='NAV' && isAdvisor && !currentClient &&
            <React.Fragment>
              <Menu.Item
                name='prospects'
                active={activeItem === 'prospects'}
                as={Link}
                to={'/advisor/prospects'}
                >
                Prospects
              </Menu.Item>  
              <Menu.Item
                name='messages'
                active={activeItem === 'messages'}
                as={Link}
                to={'/advisor/messages'}
                >
                Messages [{unread}]
              </Menu.Item> 
            </React.Fragment>
          }
          { isAdvisor && !!currentClient && 
            <Menu.Item
              name='client'
              active={activeItem === 'client'}
              as={Link}
              to={'/advisor/client'}
            >
            {!isProspect ? 'Client' : 'Prospect'}
            </Menu.Item>
          }
          { process.env.REACT_APP_TYPE==='NAV' && !isAdvisor && 
            <Menu.Item
              name='home'
              active={activeItem === 'home'}
              as={Link}
              to={'/home'}
            >
            Home
            </Menu.Item>
          }

          { (process.env.REACT_APP_TYPE==='BMC' || activeApp==='bmc') && (!isAdvisor || (isAdvisor && currentClient)) &&
            <React.Fragment>
              { process.env.REACT_APP_TYPE==='NAV' && isAdvisor && !isProspect && 
                <Menu.Item
                  name='plans'
                  active={activeItem === 'plans'}
                  as={Link}
                  to={'advisor/bmc'}
                >
                Plans
                </Menu.Item>
              }
              <Menu.Item
                id='navThisYear'
                name='this_year'
                active={activeItem === 'thisyear'}
                as={Link}
                to='/bmc/thisyear'
              >
                This Year
              </Menu.Item>

              { (!isAdvisor || currentPlan) &&
                <React.Fragment>  
                  <Menu.Item
                    id='navFuture'
                    name='future'
                    active={activeItem === 'future'}
                    as={Link}
                    to={'/bmc/future'}
                  >
                    Future Choices
                  </Menu.Item>

                  <Menu.Item
                    id='navEvents'
                    name='events'
                    active={activeItem === 'events'}
                    as={Link}
                    to={'/bmc/events'}
                  >
                    Life Events
                  </Menu.Item>

                  <Menu.Item
                    id='navReports'
                    name='reports'
                    active={activeItem === 'reports'}
                    as={Link}
                    to='/bmc/reports'
                  >
                    Choice Assessment
                  </Menu.Item>
                  {isAdvisor && !view_only && 
                    <Menu.Item 
                      name='drawdown'
                      active={activeItem === 'drawdown'}
                      as={Link}
                      to='/advisor/drawdown'
                    >
                      Drawdown
                    </Menu.Item>
                  }
                </React.Fragment>
              }
              { !isAdvisor && 
                <Menu.Item
                  id='navTours'
                  name='tours'
                  active={activeItem === 'tours'}
                  as={Link}
                  to='/bmc/tours'
                >
                  Tours
                </Menu.Item> 
              }
            </React.Fragment>
          }
          
          { isAdvisor && clientName &&
            <div className='menu-text active-client' >
              { activeName }
              { currentPlan && (' - ' + currentPlan)}
            </div>
          }
          <Menu.Menu position='right'>
            { isAdvisor && !currentClient && 
              <React.Fragment>
                <Menu.Item header style={{paddingTop: '7px', paddingBottom: '6px'}}>
                  Active Clients
                  <Label color='green' size='huge'>{activeClients}</Label>
                </Menu.Item>
                <Menu.Item
                  name='create'
                  active={activeItem === 'create'}
                  as={Link}
                  to='/advisor/client/create'>
                  <Icon name='user' />
                  Create Client
                </Menu.Item>
              </React.Fragment>
            } 
            { !isAdvisor &&
              <Menu.Item 
                name='faq'
                active={activeItem === 'faq'}
                as={Link}
                to='/faq'
              >
                FAQ
              </Menu.Item>
            }
            <Dropdown item text={`${displayName}`}>
              <Dropdown.Menu>
                {
                  !isAdvisor && 
                  <React.Fragment>
                    <Dropdown.Item id='navMyAccount' name='user' as={Link} to='/settings'>My Account</Dropdown.Item>
                    <Dropdown.Item name='user' as={Link} to={{pathname: '/settings'}} state={{page: 'settings'}}>{isTrial ? 'Plan Settings' : 'Restore Point'}</Dropdown.Item>
                    { process.env.REACT_APP_TYPE==='BMC' &&
                      <Dropdown.Item name='user' as={Link} to={{pathname: '/settings'}} state={{page: 'subscription'}}>Subscription</Dropdown.Item>
                    }
                  </React.Fragment>
                }
                { 
                  isAdvisor && 
                  <React.Fragment>
                    {currentClient && <Dropdown.Item name='close' onClick={this.closeFile}>Close {!isProspect?'Client':'Prospect'}</Dropdown.Item>}
                    <Dropdown.Item name='user' as={Link} to='/advisor/settings'>My Account</Dropdown.Item>
                    <Dropdown.Item name='user' as={Link} to='/faq'>FAQ</Dropdown.Item>
                  </React.Fragment>
                }
                <Dropdown.Item name='user' as={Link} to='/changelog'>Change Log</Dropdown.Item>
                <Dropdown.Item onClick={ this.logout }>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>  
          </Menu.Menu>          
        </Menu>
        </Sticky>
      </div>
    )
  }
}

function appendTawkTo(userName, primaryName, tawkToID) {
  const tawkTo = document.getElementById('tawkto')
  if (!tawkTo) {
    const script = document.createElement('script')
    let tawkScript = "var Tawk_API=Tawk_API||{};Tawk_API.visitor = {name : '"
    tawkScript += primaryName
    tawkScript += "',email : '"
    tawkScript += userName
    tawkScript += "'};var Tawk_LoadStart=new Date();(function(){var s1=document.createElement('script'),s0=document.getElementsByTagName('script')[0];s1.async=true;s1.src='https://embed.tawk.to/"
    tawkScript += tawkToID
    tawkScript += "';s1.charset='UTF-8';s1.setAttribute('crossorigin','*');s0.parentNode.insertBefore(s1,s0);})();"
    script.type = 'text/javascript'
    script.id = 'tawkto'
    script.appendChild(document.createTextNode(tawkScript))
    document.body.appendChild(script)  
  }
}

Navigation.propTypes = {
  user_data: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    activeClients: !state.shared_data.advisor.clients ? 0 : state.shared_data.advisor.clients.length,
    activeClient: state.shared_data.advisor.client,
    unread: !state.shared_data.messages.unread ? 0 :state.shared_data.messages.unread, 
    user_data: state.shared_data.user,
    plan: state.shared_data.bmc.futurechoices.plan,
    isAdvisor: (state.auth.status === 'advisor'),
    isTrial: (state.auth.subscription === 'trial')
  }
}

export default withRouter(connect(mapStateToProps, { logout, closeClient })(Navigation))
